const clientRoute = {
    root: '/',
    login: '/login',

    workplace: '/workplace',
    designTasks: '/design-tasks',
    expNoteFormation: '/downloadExpNoteFormationPO',
    requests: '/requests',
    requestNewPath: '/request/new(/:objectId)',
    requestNew: '/request/new',
    requestNewEpgu: (id) => '/request/new/' + id,
    requestLoader: '/request(/:objectId)',
    requestTest: '/request(/:objectId)/test',
    requestDraft: '/request(/:objectId)/draft',
    requestProject: '/request(/:objectId)/project',

    requestSubmittedNotify:  '/request(/:objectId)/notify',
    newRequestFromExpertSupport: id => `/request/${id}`,

    request: (objectId, page) => ( objectId ?
        "/request/" + objectId  :
        "/request" ) + ( page || "" ),
    user: (id) => id ? `/user/${id}` : '/user(/:id)',
    users: '/users',

    newUser: '/user',

    qualityAssessment: (objectId) => objectId ? `/qaform/${objectId}` : '/qaform(/:objectId)',
    newQualityAssessment: '/qaform',
    qualityAssessmentList: '/qa',
    submittedQualityAssessment: '/qaform/notify',

    journal: '/journal',
    requestsAll: '/requests-all',

    //landing: 'dashboard/landing.html',
    notFound: '/not-found',
    unauthorizedEsia: '/unauthorized-esia',
    landingEdit: '/landingEdit',
    landingView: '/landingView',

    systemEvents: '/system-events',
    version: '/version',

    organizations: '/organizations',
    organization: id => (id ? `/organization/${id}` : '/organization(/:id)'),
    userOrganizationsProfile: personId => (personId ? `/userProfile/${personId}` : '/userProfile(/:id)'),
    delegation: '/delegation',
    delegationView: id => (id ? `/delegation/${id}` : '/delegation(/:id)'),
    exclusions: `/exclusions`,
    accessDenied: '/access_denied',
    examinationCalendar: '/examination-calendar',
    designTask: (taskId) => taskId ? `/design-task/${taskId}` : '/design-task(/:taskId)',
};

export {clientRoute}



// WEBPACK FOOTER //
// client/config/clientRoutes.es6